const env = require('../env.json');

const isUndefined = function(obj, keyName) {
  return obj[keyName] === null || typeof obj[keyName] === 'undefined';
};

const readEnvKeyValue = function(key, subKey, obj) {
  if (isUndefined(obj, key)) {
    return null;
  }
  if (isUndefined(obj[key], subKey)) {
    if (subKey === null || typeof subKey === 'undefined') {
      return obj[key];
    } else {
      return null;
    }
  }
  return obj[key][subKey];
};

module.exports = {
  readEnv(key, subKey, obj = env['ec-client']) {
    try {
      if (obj === null || typeof obj === 'undefined' || isUndefined(obj, key)) {
        return readEnvKeyValue(key, subKey, env);
      }
      return readEnvKeyValue(key, subKey, obj);
    } catch (err) {
      throw new Error('Cannot go deeper than two layers with main env and two layers with additional subject');
    }
  }
};
